// src/components/AnalyticsFeaturesCards.jsx
import { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import {
  FiBarChart2,
  FiTrendingUp,
  FiCalendar,
  FiMapPin,
  FiMap,
  FiTarget,
  FiZap,
  FiLayers,
  FiActivity,
  FiUsers,
  FiRepeat,
  FiPieChart,
  FiCheckCircle,
  FiDatabase,
  FiAlertTriangle,
  FiEye,
  FiSliders,
  FiSearch,
  FiFilter,
  FiTable,
  FiDownloadCloud,
  FiFile,
  FiShare2,
  FiFileText,
} from "react-icons/fi";

const features = [
  {
    title: "Analiza sprzedaży i zakupów",
    subtext:
      "Szybki przegląd wartości sprzedaży i zakupów w ujęciu miesięcznym lub kwartalnym. Dzięki przejrzystym wykresom łatwo dostrzeżesz sezonowość, skoki lub spadki.\n\nMożesz porównać poszczególne okresy i zobaczyć dynamikę zmian w czasie. Narzędzie pomaga w wychwytywaniu nieoczywistych trendów i planowaniu działań na przyszłość.",
    icon: <FiBarChart2 />,
    image: "./banner1.png",
    details: [
      { text: "Porównania miesięczne i kwartalne", icon: <FiCalendar /> },
      { text: "Wizualizacja trendów sezonowych", icon: <FiBarChart2 /> },
      { text: "Analiza sprzedaży i zakupów", icon: <FiTrendingUp /> },
    ],
  },
  {
    title: "Raporty regionalne",
    subtext:
      "Poznaj geograficzną strukturę sprzedaży – według województw, miast oraz krajów kontrahentów. Analiza terytorialna pozwala zidentyfikować rynki o największym potencjale.\n\nWykresy i mapy pomagają szybko zlokalizować skupiska klientów lub nowe kierunki rozwoju.",
    icon: <FiMapPin />,
    image: "./banner2.png",
    details: [
      { text: "Województwa, miasta, kraje", icon: <FiMap /> },
      { text: "Wizualizacja na mapach", icon: <FiTarget /> },
      { text: "Wsparcie decyzji marketingowych", icon: <FiTrendingUp /> },
    ],
  },
  {
    title: "Raporty kreatywne",
    subtext:
      "Alternatywne sposoby spojrzenia na dane – poza typową księgowością.\n\nZestawienia tematyczne, eksperymentalne wizualizacje i nietypowe przekroje danych.",
    icon: <FiZap />,
    image: "./banner3.png",
    details: [
      { text: "Nietypowe wizualizacje", icon: <FiActivity /> },
      { text: "Zestawienia tematyczne", icon: <FiLayers /> },
      { text: "Wsparcie strategiczne", icon: <FiTrendingUp /> },
    ],
  },
  {
    title: "Zestawienie kontrahentów",
    subtext:
      "Zobacz, z kim najczęściej współpracujesz i jaka jest wartość transakcji z poszczególnymi kontrahentami.\n\nPodsumowanie obejmuje liczbę faktur, łączną wartość i średnią kwotę transakcji.",
    icon: <FiUsers />,
    image: "./banner4.png",
    details: [
      { text: "Najważniejsi partnerzy", icon: <FiUsers /> },
      { text: "Transakcje sprzedaży/zakupu", icon: <FiRepeat /> },
      { text: "Analiza wartości i częstotliwości", icon: <FiPieChart /> },
    ],
  },
  {
    title: "Weryfikacja kontrahentów",
    subtext:
      "Sprawdź status VAT, wypłacalność, dane rejestrowe i historię działalności.\n\nTo realne wsparcie w ocenie ryzyka współpracy.",
    icon: <FiCheckCircle />,
    image: "./banner5.png",
    details: [
      { text: "Dane zewnętrzne i finansowe", icon: <FiDatabase /> },
      { text: "Historia działalności", icon: <FiCheckCircle /> },
      { text: "Ocena ryzyka współpracy", icon: <FiAlertTriangle /> },
    ],
  },
  {
    title: "Wykrywanie nietypowych transakcji",
    subtext:
      "System automatycznie identyfikuje transakcje odbiegające od normy – wysokie kwoty, nowe podmioty lub dziwne stawki VAT.\n\nIdealne do kontroli i audytów.",
    icon: <FiEye />,
    image: "./banner6.png",
    details: [
      { text: "Ostrzeżenia o odchyleniach", icon: <FiAlertTriangle /> },
      { text: "Filtr bez kodowania", icon: <FiSliders /> },
      { text: "Wspiera kontrole i audyty", icon: <FiSearch /> },
    ],
  },
  {
    title: "Raporty miesięczne i roczne",
    subtext:
      "Gotowe podsumowania działalności w różnych okresach czasowych.\n\nTabele i wykresy do porównań między miesiącami i latami.",
    icon: <FiCalendar />,
    image: "./banner7.png",
    details: [
      { text: "Dane czasowe (M, Q, Y)", icon: <FiCalendar /> },
      { text: "Automatyczne wykresy", icon: <FiBarChart2 /> },
      { text: "Filtr wg VAT / typu", icon: <FiFilter /> },
    ],
  },
  {
    title: "Eksport danych i wykresów",
    subtext:
      "Eksportuj zestawienia do Excela i PDF.\n\nPrzydatne dla księgowości, doradców i prezentacji.",
    icon: <FiDownloadCloud />,
    image: "./banner8.png",
    details: [
      { text: "Excel i PDF", icon: <FiFile /> },
      { text: "Podsumowania i źródła", icon: <FiShare2 /> },
      { text: "Gotowe do druku", icon: <FiDownloadCloud /> },
    ],
  },
  {
    title: "Szybki podgląd pliku JPK VAT",
    subtext:
      "Zobacz zawartość JPK bez zewnętrznych narzędzi.\n\nSprawdź strukturę, kompletność i nietypowe pola.",
    icon: <FiFileText />,
    image: "./banner9.png",
    details: [
      { text: "Podgląd bez rozpakowania", icon: <FiFileText /> },
      { text: "Weryfikacja poprawności", icon: <FiCheckCircle /> },
      { text: "Podświetlenie błędów", icon: <FiAlertTriangle /> },
    ],
  },
];

export default function AnalyticsFeaturesCards() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Section id="features">
      <Wrapper>
        <SectionTitle>
          Podstawowe raporty i funkcje AnalizyiRaporty.pl
        </SectionTitle>

        {isMobile ? (
          // 👉 Accordion View
          <Grid>
            {features.map((item, index) => {
              const isOpen = activeIndex === index;
              return (
                <Card
                  key={index}
                  onClick={() => handleToggle(index)}
                  $active={isOpen}
                >
                  <CardHeader>
                    <Icon>{item.icon}</Icon>
                    <Title>{item.title}</Title>
                    <Arrow $active={isOpen}>{isOpen ? "▲" : "▼"}</Arrow>
                  </CardHeader>

                  {isOpen && (
                    <>
                      <ExpandedSubtext>{item.subtext}</ExpandedSubtext>
                      <DetailsList>
                        {item.details.map((detail, i) => (
                          <DetailItem key={i}>
                            <DetailIcon>{detail.icon}</DetailIcon>
                            <span>{detail.text}</span>
                          </DetailItem>
                        ))}
                      </DetailsList>
                    </>
                  )}
                </Card>
              );
            })}
          </Grid>
        ) : (
          // 👉 Desktop Grid + Bottom Panel
          <>
            <Grid>
              {features.map((item, index) => (
                <Card
                  key={index}
                  onClick={() => handleToggle(index)}
                  $active={activeIndex === index}
                >
                  <CardHeader>
                    <Icon>{item.icon}</Icon>
                    <Title>{item.title}</Title>
                    <Arrow $active={activeIndex === index}>
                      {activeIndex === index ? "▲" : "▼"}
                    </Arrow>
                  </CardHeader>
                </Card>
              ))}
            </Grid>

            {activeIndex !== null && (
              <ExpandedPanel>
                <ExpandedContent>
                  <LeftColumn>
                    <ExpandedSubtext>
                      {features[activeIndex].subtext}
                    </ExpandedSubtext>
                    <DetailsList>
                      {features[activeIndex].details.map((detail, i) => (
                        <DetailItem key={i}>
                          <DetailIcon>{detail.icon}</DetailIcon>
                          <span>{detail.text}</span>
                        </DetailItem>
                      ))}
                    </DetailsList>
                  </LeftColumn>
                  <RightColumn>
                    <img
                      src={features[activeIndex].image}
                      alt={features[activeIndex].title}
                    />
                  </RightColumn>
                </ExpandedContent>
              </ExpandedPanel>
            )}
          </>
        )}

        <div style={{ textAlign: "center" }}>
          <CTAButton href="/register-demo">Zarezerwuj DEMO →</CTAButton>
        </div>
        {/*                   <ImageWrapper>
      <img src="./banner3.jpg" alt="Jak to działa - ilustracja" />
    </ImageWrapper> */}
      </Wrapper>
    </Section>
  );
}

const ImageWrapper = styled.div`
  margin-top: 4rem;
  text-align: center;

  img {
    max-width: 100%;
    height: 50vh;
    border-radius: 12px;
  }
`;

const expand = keyframes`
  from {
    opacity: 0;
    transform: scaleY(0.95);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
`;

const Wrapper = styled.section`
  padding: 4rem 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  backdrop-filter: blur(20px);
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.2rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 1.3;
  }
`;

const Section = styled.section`
  padding: 1rem 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  position: relative;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
`;

const Icon = styled.div`
  font-size: 1.5rem;
  color: #3bc3cc;
`;

const Grid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
`;
const Card = styled.div`
  background: ${({ $active }) =>
    $active ? "#1f2937" : "rgba(255, 255, 255, 0.2)"};
  color: ${({ $active }) => ($active ? "#ffffff" : "#1f2937")};
  backdrop-filter: blur(18px);
  border-radius: 16px;
  border: 1px solid
    ${({ $active }) => ($active ? "#1f2937" : "rgba(255, 255, 255, 0.4)")};
  box-shadow: ${({ $active }) =>
    $active
      ? "0 10px 25px rgba(0, 0, 0, 0.3)"
      : "0 4px 12px rgba(0, 0, 0, 0.08)"};
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${({ $active }) => ($active ? "scale(1.03)" : "none")};

  &:hover {
    transform: scale(1.04);
    border-color: #3bc3cc;
  }

  ${Title} {
    color: ${({ $active }) => ($active ? "#ffffff" : "#1f2937")};
  }

  ${Icon} {
    color: ${({ $active }) => ($active ? "#3bc3cc" : "#3bc3cc")};
  }
`;
const Arrow = styled.div`
  font-size: 1.3rem;
  color: ${({ $active }) => ($active ? "#d1d5db" : "#6b7280")};
  justify-self: end;
`;

const CardHeader = styled.div`
  display: grid;
  grid-template-columns: 2rem 1fr 1.5rem;
  align-items: center;
  gap: 1rem;
`;

const DetailsList = styled.ul`
  list-style: none;
  margin-top: 1rem;
  padding-left: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const DetailItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 0;
  font-size: 1rem;
  color: #374151;

  span {
    font-weight: 500;
  }

  @media (max-width: 768px) {
    color: #e5e7eb;

    span {
      color: #e5e7eb; // Ensure the span text inherits mobile color too
    }
  }
`;

const CTAButton = styled.a`
  display: inline-block;
  margin: 3rem auto 0;
  padding: 1rem 3rem;
  background-color: #3bc3cc;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: black;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.8rem 2rem;
    text-align: center;
  }
`;
const DetailIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #22c55e;
`;
const ExpandedPanel = styled.div`
  margin-top: 3rem;
  padding: 2rem 2.5rem;
  animation: ${expand} 0.35s ease;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  color: #1f2937;
`;

const ExpandedSubtext = styled.p`
  white-space: pre-line;
  font-size: 1rem;
  color: #374151;
  line-height: 1.7;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    color: #e5e7eb; /* light gray on dark cards */
  }
`;

const ExpandedContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    flex-direction: row;
    gap: 3rem;
  }
`;

const LeftColumn = styled.div`
  flex: 1;
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 420px;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;
